import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { FaUser } from "react-icons/fa";
import { FaBuilding } from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaMoneyBill } from "react-icons/fa";
import { TbArrowsUpDown } from "react-icons/tb";
import { useDispatch, useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import { getBrokeragesList, loadBrokerages } from "../../store/brokerages";
import BrokerageView from "./BrokerageView";
import { Pagination } from "react-bootstrap";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  ArcElement,
  Legend,
} from "chart.js";
import { Bar, Pie, Line } from "react-chartjs-2";
import AdminView from "./AdminView";

const BAR = "BAR";
const LINE = "LINE";
const PIE = "PIE";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const StatisticCard = (props) => {
  const cardInfo = props.cardInfo;

  return (
    <>
      <Card
        style={{
          display: "inline-block",
          width: cardInfo.width ? cardInfo.width : "10rem",
          margin: cardInfo.margin ? cardInfo.margin : "10px",
        }}
      >
        <Card.Img
          variant="top"
          //   src="https://www.toptal.com/designers/subtlepatterns/uploads/moroccan-flower.png"
        />
        {/* <Card.ImgOverlay> */}
        <Card.Body>
          <Container>
            <Row className="justify-content-md-center">
              <Col className="d-flex justify-content-center align-items-center flex-column  gap-3">
                {cardInfo.icon && (
                  <span style={{ marginBottom: "20px" }}>
                    <cardInfo.icon size={"34px"} />
                  </span>
                )}
                <span>
                  <h6>{cardInfo.title}</h6>
                </span>
                <span>
                  <h4>{cardInfo.data} </h4>
                </span>
              </Col>
            </Row>
          </Container>
        </Card.Body>
        {/* </Card.ImgOverlay> */}
      </Card>
    </>
  );
};

const StatisticTable = ({ data, headers, itemsPerPage, handleRowClick }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handleClick = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total number of pages
  const totalPages = Math.ceil(data.length / itemsPerPage);

  // Get the data for the current page
  const currentData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Table hover>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr key={index}>
              {headers.map((header, i) => {
                let value = item[header.field];

                if (header.type === "date" && value) {
                  value = new Date(value).toLocaleDateString();
                } else if (header.type === "array" && value) {
                  value = value.length;
                }

                return (
                  <td
                    onClick={() =>
                      handleRowClick({ item: item, view: "brokerage" })
                    }
                    key={i}
                  >
                    {value ? value : ""}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-center">
        <Pagination>
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => handleClick(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      </div>
    </>
  );
};

const ReportsChart = (props) => {
  const reportData = props.reportData;
  const reportTitle = props.reportTitle;
  const reportChartType = props.reportChartType;
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: reportTitle,
      },
    },
  };

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "Nick Da Kid Brokerage",
        data: [4, 34, 34, 34, 34, 34, 39],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Lenny Jenkin Brokrage	",
        data: [4, 34, 34, 74, 34, 34, 34],
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "Ram Vam Dam Brokerage		",
        data: [4, 34, 34, 34, 84, 34, 34],
        backgroundColor: "#808080",
      },
    ],
  };

  return (
    <>
      {reportChartType === LINE ? (
        <Line options={options} data={reportData ? reportData : data} />
      ) : reportChartType === BAR ? (
        <Bar options={options} data={reportData ? reportData : data} />
      ) : (
        <Pie options={options} data={reportData ? reportData : data} />
      )}
    </>
  );
};

const Reports = () => {
  const brokeragesList = useSelector(getBrokeragesList);
  const [brokerList, setBrokerList] = useState([]);
  const [brokerages, setBrokerages] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedInsight, setSelectedInsight] = useState();
  const [view, setView] = useState("main");

  useEffect(() => {
    var tempBrokerList = [];

    //Need to structure the data to have only the relevant details of brokerages
    const tempBrokerages = brokeragesList.map((brokerage) => {
      tempBrokerList = [...tempBrokerList, ...brokerage.active_brokers];

      return {
        title: brokerage.name,
        activeBrokers: brokerage.active_brokers,
      };
    });
    setBrokerList(tempBrokerList);
  }, []);

  const cards = [
    { icon: FaBuilding, title: "Brokerages", data: brokeragesList.length },
    { icon: FaUser, title: "Brokers", data: brokerList.length },
    {
      icon: TbArrowsUpDown,
      title: "Total Transactions",
      data: 9800,
    },
    {
      icon: FaUserFriends,
      title: "Total Prospects",
      data: 5000,
    },
    {
      icon: FaMoneyBill,
      title: "Total Revenue",
      data: 10000,
    },
  ];

  const headers = [
    { label: "Name", field: "name", type: "string" },
    // { label: "Code", field: "code", type: "string" },
    // { label: "Website", field: "website", type: "string" },
    // { label: "Contact Number", field: "contact_number", type: "string" },
    { label: "Next Renew Date", field: "next_renew_date", type: "date" },
    { label: "Active Brokers", field: "active_brokers", type: "array" },
  ];

  const handleClick = (data) => {
    setSelectedItem(data.item);
    changeView(data.view);
  };

  const changeView = (viewName) => {
    setView(viewName);
  };

  // const subCategory = [
  //   {
  //     icon: TbArrowsUpDown,
  //     title: "Total Transactions",
  //     data: 9800,
  //     width: "16rem",
  //     margin: "12px",
  //   },
  //   {
  //     // icon: FaUserFriends,
  //     title: "Total Prospects",
  //     data: 5000,
  //     width: "16rem",
  //     margin: "12px",
  //   },
  //   {
  //     // icon: FaMoneyBill,
  //     title: "Total Revenue",
  //     data: 10000,
  //     width: "16rem",
  //     margin: "12px",
  //   },
  // ];

  return (
    <>
      {/* {view === "main" && (
        <Col>
          <Row>
            {cards.map((cardInfo) => {
              return <StatisticCard cardInfo={cardInfo} />;
            })}
          </Row>

          <Row>
            <Col md={12}>
              <StatisticTable
                data={brokeragesList}
                headers={headers}
                itemsPerPage={5}
                handleRowClick={(data) => handleClick(data)}
              />
            </Col>
            <Col md={12}>
              <ReportsChart reportChartType={LINE} reportTitle={"# of Users"} />
            </Col>
          </Row>
        </Col>
      )} */}
      {view === "main" && (
        <AdminView brokerageRowClick={(data) => handleClick(data)} />
      )}

      {view === "brokerage" && <BrokerageView brokerage={selectedItem} />}
    </>
  );
};

export default Reports;
